import React, { memo, useRef, useState, useEffect } from "react";
import ImageComponent from "./ImageComponent.jsx";

const ImageWithAspectRatio = ({
  sizes,
  aspectRatio,
  height,
  src,
  alt = "Medical post media",
  onClick,
}) => {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!containerRef.current) return undefined;
    const update = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.clientWidth || 0);
      }
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  // width / sizes
  const sizeValue = Number(sizes || aspectRatio) || (height ? 555 / Number(height) : 1.78);
  const calculatedHeight = width > 0 ? `${Math.round(width / sizeValue)}px` : undefined;

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: calculatedHeight,
        aspectRatio: !calculatedHeight ? `${sizeValue}` : undefined,
        backgroundColor: "#F8FAFC",
        position: "relative",
        overflow: "hidden",
      }}
      onClick={onClick}
    >
      <ImageComponent
        src={src}
        alt={alt}
        img_height="100%"
        img_width="100%"
        loader_height={calculatedHeight || "100%"}
        loader_width="100%"
        compClassName="object-cover w-100 h-100"
        onClick={onClick}
      />
    </div>
  );
};

export default memo(ImageWithAspectRatio);
